import type { IAccountAccreditation } from './AccountAccreditation.interface';

export default class AccountAccreditation implements IAccountAccreditation {
  id: string;
  organization: string;
  website: string;
  username: string;
  password: string;
  notes: string;

  static build = (data: IAccountAccreditation) => new AccountAccreditation(data);
  static blank = () => new AccountAccreditation();

  /**
   * Constructor
   * @param {IAccountAccreditation} data
   */
  constructor(data?: IAccountAccreditation) {
    this.id = data?.id || '';
    this.organization = data?.organization || '';
    this.website = data?.website || undefined;
    this.username = data?.username || undefined;
    this.password = data?.password || undefined;
    this.notes = data?.notes || undefined;
  }
}
